import { WeightConversion } from '@common/models/Enums';
/**
 * Takes any number that might have decimal places and truncates it exactly, with no rounding errors to the desired decimal places
 * Math.trunc was observed to be producing the incorrect truncation on certain scenarios, like 4.26 becoming 4.25, which is incorrect.
 * Using a string based method, guarantees that we do not round.
 * @param number
 * @param numberOfDecimals
 * @returns
 */
export const toFixedTruncate = (number: number, numberOfDecimals: number = 2) => {
    const regex = "^-?\\d+(?:\\.\\d{0," + numberOfDecimals + "})?"
    const pattern = RegExp(regex, "g");
    const match = number.toString().match(pattern);
    return parseFloat(match?.[0] ?? '0');
}

export const convertToKG = (weight?: number) =>
    weight ? Number(weight * WeightConversion.PoundToKg).toFixed(2) : 0;
